module.exports = __webpack_public_path__ + "static/devices-fr-e63f4e788926e3ad7ffd1b4bb8625eb6.jpg";